import React, { useEffect, useRef } from 'react';
import { logoutUser, getCurrentUser } from '@/lib/api';
import { useToast } from '@/components/ui/use-toast';

/**
 * Composant invisible qui déconnecte après X minutes sans activité utilisateur.
 * Activité = mousemove, mousedown, keydown, scroll, touchstart, retour onglet visible.
 */
const IdleSessionManager = ({ timeoutMinutes = 10 }) => {
  const timerRef = useRef(null);
  const { toast } = useToast();

  useEffect(() => {
    const token = localStorage.getItem('tdv_auth_token');
    if (!token) return; // pas loggé -> rien

    const LIMIT_MS = timeoutMinutes * 60 * 1000;

    const resetTimer = () => {
      if (!localStorage.getItem('tdv_auth_token')) return;
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        const user = getCurrentUser();
        if (user) {
          logoutUser();
          toast({
            title: 'Session expired',
            description: `Logged out after ${timeoutMinutes} minutes of inactivity.`,
          });
        }
      }, LIMIT_MS);
    };

    const events = ['mousemove','mousedown','keydown','touchstart','scroll'];
    events.forEach(e => window.addEventListener(e, resetTimer));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') resetTimer();
    });

    // initial
    resetTimer();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, resetTimer));
      document.removeEventListener('visibilitychange', resetTimer);
    };
  }, [timeoutMinutes]);

  return null;
};

export default IdleSessionManager;